import { render } from "./elements.vue?vue&type=template&id=712a23e0"
import script from "./elements.vue?vue&type=script&lang=js"
export * from "./elements.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/elements.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "712a23e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('712a23e0', __exports__)) {
    console.log('reload')
    api.reload('712a23e0', __exports__)
  }
  
  module.hot.accept("./elements.vue?vue&type=template&id=712a23e0", () => {
    console.log('re-render')
    api.rerender('712a23e0', render)
  })

}


export default __exports__